/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */





$(document).ready(function () {

  function initializeSlick() {
    $('.tab_collections .product-list__inner').each(function () {
      if ($(window).width() > 768) {
        if (!$(this).hasClass('slick-initialized')) {
          $(this).slick({
            slidesToShow: 4.5,
            slidesToScroll: 2,
            infinite: false,
            arrows: false,
            dots: false,
            speed: 400,
            easing: 'ease-in-out',
            responsive: [
              {
                breakpoint: 768,
                settings: {
                  slidesToShow: 2,
                   slidesToScroll: 1,
                },
              },
              {
                breakpoint: 480,
                settings: {
                  slidesToShow: 1,
                     slidesToScroll: 1,
                },
              },
            ],
          });
        }
      } else {
        if ($(this).hasClass('slick-initialized')) {
          $(this).slick('unslick'); 
        }
      }
    });
  }

  initializeSlick();

  $(window).on('resize', function () {
    initializeSlick();
  });

  $('.tabs-nav__item').on('click', function () {
    setTimeout(function () {
      $('.tab_collections .product-list__inner').slick('setPosition');
    }, 300);
  });


  const faqItems = document.querySelectorAll('.faq-item');
  faqItems.forEach(item => {
    const questionButton = item.querySelector('.faq-question');

    questionButton.addEventListener('click', () => {
      if (item.classList.contains('expanded')) {
        item.classList.remove('expanded');
      } else {
        faqItems.forEach(i => i.classList.remove('expanded'));
        item.classList.add('expanded');
      }
    });
  });
$('.footer__item.footer__item--links').click(function() {
    if ($(this).hasClass('active')) {
        $(this).removeClass('active');
    } else {
        $('.footer__item.footer__item--links').removeClass('active');
        $(this).addClass('active');
    }
});
  $('.header__icon-list a').click(function(){
$('#mobile-menu-drawer').removeAttr('open');
});
});

document.addEventListener('DOMContentLoaded', function () {

  const buttons = document.querySelectorAll('.filter-button');
  const cards = document.querySelectorAll('.result-card');

  function applyFilter(filter){
    cards.forEach(card => {
      if (filter === 'all' || card.getAttribute('data-category') === filter) {
        card.style.display = 'block';
      } else {
        card.style.display = 'none';
      }
    });
  }

  buttons.forEach(button => {
    button.addEventListener('click', function () {

      const filter = this.getAttribute('data-filter');

      applyFilter(filter);

      buttons.forEach(btn => btn.classList.remove('active'));
      this.classList.add('active');

    });
  });

  // ✅ Apply filter on page load
  const activeButton = document.querySelector('.filter-button.active');
  if(activeButton){
    applyFilter(activeButton.getAttribute('data-filter'));
  }

});

document.addEventListener("DOMContentLoaded", function(){

  const purchaseOptions = document.querySelectorAll('[name="purchase_type"]');
  const subscriptionBox = document.querySelector('.subscription-options');

  let lastPlan = null;

  function clickAppstle(plan){
    const el = document.querySelector('.appstleSellingPlan0[value="'+plan+'"]');
    if(el){
      el.click();
    }
  }

  // TOGGLE UI
  purchaseOptions.forEach(option=>{
    option.addEventListener("change", function(){

      if(this.value === "subscription"){
        subscriptionBox.style.display = "flex";
      } else {
        subscriptionBox.style.display = "none";
      }

    });
  });

  // CHANGE EVENTS (GLOBAL)
  document.addEventListener("change", function(e){

    if(e.target.matches('input[value="onetime"]')){
      const oneTime = document.querySelector('.appstleSellingPlan0[value=""]');
      if(oneTime) oneTime.click();
    }

    if(e.target.matches('input[value="subscription"]')){
      if(lastPlan){
        clickAppstle(lastPlan);
      } else {
        const firstPlan = document.querySelector('[name="subscription_plan"]:checked');
        if(firstPlan){
          lastPlan = firstPlan.value;
          clickAppstle(lastPlan);
        }
      }
    }

    if(e.target.matches('[name="subscription_plan"]')){
      lastPlan = e.target.value;
      clickAppstle(lastPlan);
    }

  });

  // ✅ LOAD FIX (retry instead of fixed timeout)
  function initAppstleSync(){

    const defaultPurchase = document.querySelector('[name="purchase_type"]:checked');
    const defaultPlan = document.querySelector('[name="subscription_plan"]:checked');
    const appstleLoaded = document.querySelector('.appstleSellingPlan0');

    if(!appstleLoaded){
      // retry until Appstle loads
      setTimeout(initAppstleSync, 300);
      return;
    }

    if(defaultPurchase && defaultPurchase.value === "subscription"){

      if(subscriptionBox){
        subscriptionBox.style.display = "flex";
      }

      if(defaultPlan){
        lastPlan = defaultPlan.value;
        clickAppstle(lastPlan);
      }

    } else {

      if(subscriptionBox){
        subscriptionBox.style.display = "none";
      }

      const oneTime = document.querySelector('.appstleSellingPlan0[value=""]');
      if(oneTime){
        oneTime.click();
      }

    }
  }

  // run it
  initAppstleSync();

});

